import {createLogger} from "vuex";

export default {
    namespaced: true,
    state() {
        return {
            userLogged: null
        }
    },
    actions: {
        async setUserLogged({commit, dispatch}) {
            dispatch('app/setLoader', 'loading', {root: true})

            let data = (await axios.get('/api/me')).data;

            commit('setUserLogged', data);
            //dispatch('app/setLoader', 'loaded', {root: true})
        },
    },
    mutations: {
        setUserLogged(state, user) {
            state.userLogged = user;
        },
    },
    plugins: [createLogger()]
}